export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_jp-bbd2a59e0f6a53267d2682ff6cb5f092.png";